import React from 'react'
import PropTypes from 'prop-types'

export function Footer (props) {
  return (
    <div className='footer d-flex align-items-center'>
      <div>
        <p><small>© <a href='https://www.oneadvanced.com/' target='blank'>Advanced</a>. All rights reserved. Version {props.version}</small></p>
      </div>
    </div>
  )
}

Footer.propTypes = {
  version: PropTypes.string.isRequired
}
